/** Champ liste « Situation professionnelle Personne N » (CDI / CDD / Autre). */
export function isSituationProListField(name) {
  return /^situation professionnelle personne\s+\d/i.test(String(name || "").trim());
}

/** Champ texte « Précision situation professionnelle Personne N » (affiché si Autre). */
export function isSituationProPrecisionField(name) {
  return /^pr[ée]cision situation professionnelle personne\s+\d/i.test(String(name || "").trim());
}

export function precisionFieldNameForSituationPro(listFieldName) {
  const m = String(listFieldName || "").match(/personne\s+(\d+)/i);
  if (!m) return null;
  return `Précision situation professionnelle Personne ${m[1]}`;
}

export function isAutreSituationProValue(value) {
  return String(value || "").trim().toLowerCase() === "autre";
}

export function isSituationMaritaleField(name) {
  return normalizeChampNomKey(name) === "situation maritale";
}

export function isCelibataireMaritalValue(value) {
  const v = String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  return v === "celibataire";
}

/** Situation pro (personne 1 ou 2) : masquée si « Situation maritale » = Célibataire. */
export function shouldHideSituationProField(name, customFields, champs) {
  if (!isSituationProListField(name) && !isSituationProPrecisionField(name)) return false;
  const cf = customFields && typeof customFields === "object" ? customFields : {};
  let marital = null;
  for (const [k, v] of Object.entries(cf)) {
    if (isSituationMaritaleField(k)) {
      marital = v;
      break;
    }
  }
  if (marital == null) {
    for (const c of champs || []) {
      if (c?.nom && isSituationMaritaleField(c.nom) && Object.prototype.hasOwnProperty.call(cf, c.nom)) {
        marital = cf[c.nom];
        break;
      }
    }
  }
  return isCelibataireMaritalValue(marital);
}

export function normalizeChampNomKey(nom) {
  return String(nom || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/** Produits PV / PAC RAC / isolation murs ext. — ordre de formulaire harmonisé. */
export function isQualificationProduitNom(nomProduit) {
  const n = String(nomProduit || "").toLowerCase();
  return (
    /panneaux.*photovolta/.test(n) ||
    /pompe.*chaleur.*rac/.test(n) ||
    /isolation.*murs.*ext/.test(n)
  );
}

function isChiffreQualificationChamp(c) {
  const k = normalizeChampNomKey(c?.nom);
  if (k.includes("revenu")) return true;
  if (k.includes("credit") || k.includes("crédit")) return true;
  if (k.includes("nombre de personnes")) return true;
  if (k.includes("facture") && (k.includes("electric") || k.includes("éléctric") || k.includes("électri"))) {
    return true;
  }
  return false;
}

/**
 * Clé de tri pour l’affichage des champs qualification :
 * A masqués (+ pays/dépt publics avant adresse) → pré-B (propriétaire, type habitation)
 * → B situations → C chiffres → D produit.
 */
export function qualificationChampSortKey(c) {
  const k = normalizeChampNomKey(c?.nom);
  if (k === "nom du client") return 10;
  if (k === "telephone du client" || k === "tel du client") return 20;
  if (k === "pays" || k === "country") return 30;
  if (k === "departement" || k === "département" || k.includes("departement")) return 40;
  if (k === "adresse du client" || k === "adresse client") return 50;
  if (k.includes("proprietaire ou locataire") || k.includes("propriétaire ou locataire")) return 60;
  if (k.includes("type d'habitation") || k.includes("type d habitation")) return 65;
  if (k.includes("situation maritale")) return 70;
  if (/^situation professionnelle personne 1/.test(k)) return 80;
  if (/^precision situation professionnelle personne 1/.test(k) || /^précision situation professionnelle personne 1/.test(k)) {
    return 90;
  }
  if (/^situation professionnelle personne 2/.test(k)) return 100;
  if (/^precision situation professionnelle personne 2/.test(k) || /^précision situation professionnelle personne 2/.test(k)) {
    return 110;
  }
  if (k.includes("nombre de personnes")) return 120;
  if (k.includes("revenu")) return 130;
  if (k.includes("credit") || k.includes("crédit")) return 140;
  if (k.includes("facture") && (k.includes("electric") || k.includes("éléctric") || k.includes("électri"))) {
    return 150;
  }
  if (isChiffreQualificationChamp(c)) return 155;
  const baseOrdre = c?.ordre != null ? Number(c.ordre) : 0;
  return 200 + baseOrdre;
}

export function sortProduitChampsForDisplay(champs, { produitNom } = {}) {
  const list = Array.isArray(champs) ? [...champs] : [];
  if (!list.length || !produitNom || !isQualificationProduitNom(produitNom)) return list;
  return list.sort((a, b) => {
    const ka = qualificationChampSortKey(a);
    const kb = qualificationChampSortKey(b);
    if (ka !== kb) return ka - kb;
    const oa = a?.ordre != null ? Number(a.ordre) : 0;
    const ob = b?.ordre != null ? Number(b.ordre) : 0;
    if (oa !== ob) return oa - ob;
    return String(a?.nom || "").localeCompare(String(b?.nom || ""), "fr");
  });
}
